const employee = () => import('@/views/main/system/employee/employee.vue')
export default {
  path: '/main/system/emp',
  name: 'system-employee',
  component: employee,
  children: []
}
